export default __webpack_public_path__ + "static/media/type-palmately-compound-leaf.76480091.PNG";